/**
 * orga-app-api - qschecks-v1-oa3_1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface WertItem { 
    hat_wert?: boolean;
    wert?: number;
    hat_kritischen_wert?: boolean;
    farbe?: string;
}

